import React from 'react';
import {RouterProvider } from 'react-router-dom';
import router from './router';
import './index.css'
import useAuthCheck from './hooks/useAuthCheck';

function App() {
  const authChecked = useAuthCheck();

  return !authChecked ? (
    <div className='flex justify-center items-center relative w-screen h-screen'>
      <div className='absolute w-12 h-12 border-4 border-gray-100 rounded-full'></div>
      <div style={{borderColor:'rgb(124 58 237 / var(--tw-bg-opacity))',borderTopColor:'transparent'}} className='absolute w-12 h-12 border-4 rounded-full animate-spin'></div>
    </div>
  ) : <RouterProvider router={router} />
}

export default App;
